module.exports = __webpack_public_path__ + "static/bg768-0e447b083b7fe2f9e47e5bf462a92e97.jpg";